<template>
  <footer class="bg-gascon-gold text-white py-12">
    <div class="container mx-auto px-4 max-w-5xl">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
        <!-- Logo and tagline -->
        <div class="md:col-span-1">
          <img src="/images/logo-white.svg" alt="Comptoir Gascon" class="h-16 mb-4" />
          <p class="text-sm text-white/70">
            Grossiste et distributeur<br />
            de produits choisis
          </p>
        </div>

        <!-- Address -->
        <div>
          <h4 class="font-bold mb-4">Adresse</h4>
          <p class="text-sm text-white/80">
            MIN de Brienne<br />
            110 Quais de Paludate<br />
            33800 Bordeaux
          </p>
          <p class="text-sm text-white/80 mt-2">
            <a href="tel:0981736002" class="hover:text-gascon-blue transition-colors">09 81 73 60 02</a>
          </p>
        </div>

        <!-- Hours -->
        <div>
          <h4 class="font-bold mb-4">Horaires</h4>
          <p class="text-sm text-white/80">
            Lundi au Vendredi<br />
            10h00 - 20h00
          </p>
          <p class="text-sm text-white/80 mt-2">
            Samedi<br />
            9h30 - 13h00
          </p>
        </div>

        <!-- Newsletter (disabled for now) -->
        <div class="opacity-50">
          <h4 class="font-bold mb-4">S'abonner à notre newsletter</h4>
          <form class="flex flex-col gap-2">
            <input
              type="email"
              placeholder="Email"
              class="px-4 py-2 bg-white/10 border border-white/20 rounded text-white placeholder-white/50 cursor-not-allowed"
              disabled
            />
            <button
              type="button"
              class="bg-white/30 text-white px-4 py-2 font-semibold cursor-not-allowed"
              disabled
            >
              BIENTÔT DISPONIBLE
            </button>
          </form>
        </div>
      </div>

      <!-- Copyright -->
      <div class="border-t border-white/20 mt-8 pt-8 text-center text-sm text-white/60">
        <p>&copy; {{ currentYear }} Comptoir Gascon. Tous droits réservés.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      email: '',
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  },
  methods: {
    async subscribeNewsletter() {
      if (!this.email) return

      try {
        const response = await fetch('/api/newsletter', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
          },
          body: JSON.stringify({ email: this.email })
        })

        if (response.ok) {
          alert('Merci pour votre inscription !')
          this.email = ''
        } else {
          alert('Une erreur est survenue. Veuillez réessayer.')
        }
      } catch (error) {
        console.error('Newsletter subscription error:', error)
        alert('Une erreur est survenue. Veuillez réessayer.')
      }
    }
  }
}
</script>
